<template>
  <v-dialog
    v-model="dialog"
    max-width="360"
    persistent
  >
    <v-toolbar
      dense
      dark
      class=""
      color="warning"
    >
      <v-toolbar-title class="text-body-1 font-weight-bold">
        Alert
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        icon
        color=""
        @click="handleCancel"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card
      tile
      flat
    >
      <v-card-text class="pa-4 font-weight-bold">
        {{ content }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          text
          @click="handleCancel"
        >
          {{ $t('m.cancel') }}
        </v-btn>
        <v-btn
          small
          text
          color="warning"
          @click="handleConfirm"
        >
          {{ $t('m.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'

export default {
  name: 'AlertConfirmDlg',
  components: { },
  props: [
    'visible', 'title', 'content'
  ],
  data () {
    return {
      dialog: false
    }
  },
  created () {
  },
  watch: {
    visible: function (val) {
      this.dialog = val
    }
  },
  methods: {
    handleConfirm () {
      this.$emit('confirm')
    },

    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
